import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalService } from '../_services/global.service';
import { ConfigPermissionOption } from '../_helpers/config-permission-option';
@Injectable()
export class AuthGeneralReportGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionGeneralReport);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
@Injectable()
export class AuthResponseRateReportGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionResponseRate);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}

@Injectable()
export class AuthSeedingReportGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionSeedingReport);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}

@Injectable()
export class AuthGeneralTopicReportGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionGeneralTopicReport);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
@Injectable()
export class AuthProcessByProjectGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionProcessByProject);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
//dashboard 1
@Injectable()
export class AuthViewDashboard1Guard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionViewDashboard1);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}
//dashboard 2
@Injectable()
export class AuthViewDashboard2Guard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionViewDashboard2);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}

//dashboard 3
@Injectable()
export class AuthViewDashboard3Guard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionViewDashboard3);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}

//dashboard 4
@Injectable()
export class AuthViewDashboard4Guard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let checkPermission = this.globalService.canPermission(this.configPermissionOption.actionViewDashboard4);
        if (!checkPermission) {
            this.router.navigate(['/dashboard']);
        } else {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_guards/auth-report.guard.ts